export const experienceData = [
  {
    category: "cat_frontend",
    skills: [
      { name: "HTML", level: "level_experienced" },
      { name: "CSS", level: "level_experienced" },
      { name: "SASS", level: "level_intermediate" },
      { name: "JavaScript", level: "level_experienced" },
      { name: "TypeScript", level: "level_intermediate" },
      { name: "React.js", level: "level_experienced" },
      { name: "Next.js", level: "level_intermediate" },
      { name: "Tailwind CSS", level: "level_intermediate" },
    ]
  },
  {
    category: "cat_mobile",
    skills: [
      { name: "React Native", level: "level_intermediate" },
      { name: "Flutter", level: "level_intermediate" },
      { name: "Dart", level: "level_intermediate" },
      { name: "Firebase", level: "level_intermediate" },
      { name: "Android Studio", level: "level_intermediate" },
      { name: "Expo", level: "level_intermediate" },
      { name: "Mobile UI/UX", level: "level_intermediate" },
      { name: "Codebase", level: "level_intermediate" },
    ]
  },
  {
    category: "cat_backend",
    skills: [
      { name: "Node.js", level: "level_intermediate" },
      { name: "PostgreSQL", level: "level_basic" },
      { name: "Python", level: "level_basic" },
      { name: "Java", level: "level_basic" },
      { name: "Git & GitHub", level: "level_intermediate" },
    ]
  },
  {
    category: "cat_telegram",
    skills: [
      { name: "Python (aiogram)", level: "level_intermediate" },
      { name: "Node.js (telegraf)", level: "level_intermediate" },
      { name: "Bot API", level: "level_intermediate" },
      { name: "Inline Keyboards", level: "level_experienced" },
    ]
  }
];
